// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cookie from 'react-cookies'
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

// Bootstrap
import { Button } from 'react-bootstrap';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './CookiesDisclaimer.css';
import rs from '../../components/storeCommon.css';

// Locale
import messages from '../../locale/messages';
class CookiesDisclaimer extends Component {

  static propTypes = {
    formatMessage: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      isCookiesSet: false,
      isPageLoad: false,
    }
    this.disclamierForm = this.disclamierForm.bind(this);
  }

  componentWillMount() {
    let cookiesValue = cookie.load('cookiesDisclaimer');
    this.setState({
      isCookiesSet: (cookiesValue) ? true : false
    });
  }

  componentDidMount() {
    let cookiesValue = cookie.load('cookiesDisclaimer');
    this.setState({
      isCookiesSet: (cookiesValue) ? true : false,
      isPageLoad: true
    });
  }

  disclamierForm() {
    let maxAge = 3650 * 24 * 365;
    cookie.save('cookiesDisclaimer', new Date().getTime(), {
      path: '/',
      maxAge
    })
    this.setState({ isCookiesSet: true })
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { isCookiesSet, isPageLoad } = this.state;
    const { siteName } = this.props;

    if (isCookiesSet) {
      return <span />;
    } else {
      return (
        <div>
          {
            isPageLoad && <div
              className={cx(s.root, s.container, s.fixedPosition)}
            >
              <div className={cx(s.cookiesBackground)}>
                <div>
                  <div className={cx(s.displayTable, s.displayTableSection)}>
                    <div className={s.displayRow}>
                      <div className={s.displayText}>
                        <span className={cx(s.labelText)}>
                          {siteName}{' '}
                          {formatMessage(messages.cookiesDisclaimer)}
                          {' '}
                          <a
                            href={'/cookie-policy'}
                            className={cx(s.labelText, s.linkStyle)}
                          >
                            {formatMessage(messages.cookiePolicy)}
                          </a>
                        </span>
                      </div>

                      <div className={cx(s.displayBtn)}>
                        <Button
                          type="button"
                          className={cx(s.button, rs.btnPrimary, 'cookiBtn', 'floatLeftRTL')}
                          onClick={this.disclamierForm}
                        >
                          {formatMessage(messages.gotIt)}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      )
    }
  }
}

const mapState = state => ({
  siteName: state.siteSettings.data.siteName
});

const mapDispatch = {};

export default injectIntl(
  withStyles(s, rs)
  (connect(mapState, mapDispatch)
  (CookiesDisclaimer))
);